//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiReload,
  mdiTableColumn,
  mdiChevronDown,
  mdiChevronUp,
  mdiPencil,
  mdiDotsVertical,
  mdiClose,
  mdiCalendarRangeOutline,
} from '@mdi/js'

export default {
  name: 'CrudModal',
  props: {
    apiURL: {
      type: [String],
      default: undefined,
    },
    modalMaxWidth: {
      type: [String],
      default: '850px',
    },
    staticModal: {
      type: [Boolean],
      default: undefined,
    },
    secondaryApiUrl: {
      type: [String],
      default: undefined,
    },
    defaultItem: {
      type: [Object],
      default: undefined,
    },
    dataItems: {
      type: [Array],
      default: undefined,
    },
    forceCreate: {
      type: [Boolean],
      default: undefined,
    },
    hideActions: {
      type: [Boolean],
      default: false,
    },
    itemId: {
      type: [Number],
      default: undefined,
    },
    forceTitle: {
      type: [String],
      default: undefined,
    },
    subTitle: {
      type: [Boolean],
      default: false,
    },
    fieldName: {
      type: [String],
      default: '',
    },
    customSuccessMsg: {
      type: [String],
      default: undefined,
    },
    enableValidationErrorsEvent: {
      type: [Boolean],
      default: false,
    },
  },
  data: () => ({
    icons: {
      mdiReload,
      mdiTableColumn,
      mdiChevronDown,
      mdiChevronUp,
      mdiPencil,
      mdiDotsVertical,
      mdiClose,
      mdiCalendarRangeOutline,
    },
    menu: {
      validTo: false,
      maintenanceTo: false,
      calibrationTo: false,
    },
    isLoading: false,
    timeout: null,
    dialog: false,
    editedIndex: -1,
    editedItem: {},
    allActive: [],
    allZones: [],
    allTypes: [],
    allHubs: [],
    allMaintenances: [],
    allWiFiOptions: [],
    allOrganizations: [],
    allScheduledPlans: [],
    selectedZone: [],
    selectedWifiMode: [],
    selectedOrganization: [],
    DeleteGlobalError: '',
    GlobalError: '',
    formErrors: {} || null,
    forceTitleSuffix: '',
  }),

  computed: {
    formTitle() {
      if (this.$i18n.locale === 'de') {
        return this.editedIndex === -1
          ? this.$t('global.createNew') + ' ' + (this.fieldName || '')
          : this.$t('global.edit') + ' ' + (this.fieldName || '')
      } else {
        return this.editedIndex === -1
          ? this.$t('global.createNew') +
              ' ' +
              (this.fieldName.toLowerCase() || '')
          : this.$t('global.edit') + ' ' + (this.fieldName.toLowerCase() || '')
      }
    },
  },

  methods: {
    async editItem(item, bulkData) {
      this.editedIndex = this.dataItems.indexOf(item)
      this.editedItem = this.$formHelpers.merge({}, this.defaultItem)

      if (bulkData !== undefined) {
        this.editedItem = this.$formHelpers.merge({}, this.editedItem, bulkData)
      }

      if (this.staticModal) {
        this.dialog = true
        this.$emit('initModalResponse')

        return
      }

      if (this.editedIndex !== -1) {
        this.isLoading = true
        this.dialog = true
        await this.$axios
          .get(
            this.apiURL +
              '/' +
              item.ID +
              '/' +
              (this.secondaryApiUrl && this.secondaryApiUrl.length
                ? this.secondaryApiUrl + '/'
                : '')
          )
          .then((resp) => {
            this.dialog = true
            this.$emit(
              'initModalResponse',
              this.$formHelpers.merge({}, resp.data.Result, item)
            )
            if (resp.data.Result.Rows && resp.data.Result.Rows[0]) {
              this.editedItem = this.$formHelpers.merge(
                {},
                resp.data.Result.Rows[0]
              )
            }
            if (this.$refs.crudModalForm) {
              this.$refs.crudModalForm.resetValidation()
            }
          })
          .catch((error) => {
            if (!error.response) {
              return error
            }
            if (error.response.data.FieldsError) {
              this.formErrors = error.response.data.FieldsError
            }

            if (error.response.data.GlobalError) {
              this.GlobalError = error.response.data.GlobalError
            }
          })
          .then(() => {
            this.isLoading = false
          })
      } else {
        return (this.dialog = true)
      }
    },

    close(withSave = true) {
      this.dialog = false
      setTimeout(() => {
        this.$refs?.crudModalForm?.reset()
        this.editedItem = this.$formHelpers.merge({}, this.defaultItem)
        this.editedIndex = -1
        this.formErrors = {}
        this.GlobalError = ''
        this.DeleteGlobalError = ''
        this.forceTitleSuffix = null
        if (this.$refs.crudModalForm) {
          this.$refs.crudModalForm.resetValidation()
        }
      }, 300)

      this.$emit('staticModalClose')

      if (withSave) {
        this.$emit('modalClose')
      }
    },

    async save() {
      if (!this.$refs.crudModalForm.validate()) {
        this.enableValidationErrorsEvent &&
          this.$emit(
            'validationErrors',
            this.getNotValidFields(this.$refs.crudModalForm)
          )
        this.$dialog.message.error(this.$t('global.message.incorrectFields'))
        return
      }
      this.isLoading = true

      this.$emit('beforeSave', this.editedItem)

      const formData = this.editedItem
      Object.keys(formData).forEach((field) => {
        if (!formData[field] && formData[field] !== 0) {
          delete formData[field]
        }
      })

      if (this.editedIndex > -1 && !this.forceCreate) {
        await this.$axios
          .put(
            this.apiURL +
              '/' +
              this.editedItem.ID +
              '/' +
              (this.secondaryApiUrl && this.secondaryApiUrl.length
                ? this.secondaryApiUrl + '/'
                : ''),
            formData
          )
          .then((resp) => {
            this.$emit('savedFromModal', resp.data || resp)
            this.$dialog.message.success(this.$t('global.message.success'))
            this.close()
            return resp
          })
          .catch((error) => {
            if (!error.response) {
              return error
            }
            if (error.response.data.FieldsError) {
              this.formErrors = error.response.data.FieldsError
              this.$dialog.message.error(
                this.$t('global.message.incorrectFields')
              )
              this.enableValidationErrorsEvent &&
                this.$emit(
                  'validationErrors',
                  this.$formHelpers.merge({}, this.formErrors)
                )
            }

            if (error.response.data.GlobalError) {
              this.GlobalError = error.response.data.GlobalError
            }
            this.$emit('saveErrors', {
              errors: error.response.data,
              data: this.$formHelpers.merge({}, this.editedItem),
            })
          })
          .then(() => {
            this.isLoading = false
          })
      } else {
        await this.$axios
          .post(
            this.apiURL +
              '/' +
              (this.secondaryApiUrl && this.secondaryApiUrl.length
                ? (this.editedItem.ID || this.itemId) +
                  '/' +
                  this.secondaryApiUrl +
                  '/'
                : ''),
            formData
          )
          .then((resp) => {
            this.$dialog.message.success(
              this.customSuccessMsg || this.$t('global.message.success')
            )
            this.close()
            return resp
          })
          .catch((error) => {
            if (!error.response) {
              return error
            }
            if (error.response.data.FieldsError) {
              this.formErrors = error.response.data.FieldsError
              this.$dialog.message.error(
                this.$t('global.message.incorrectFields')
              )
              this.enableValidationErrorsEvent &&
                this.$emit(
                  'validationErrors',
                  this.$formHelpers.merge({}, this.formErrors)
                )
            }

            if (error.response.data.GlobalError) {
              this.GlobalError = error.response.data.GlobalError
            }
            this.$emit('saveErrors', {
              errors: error.response.data,
              data: this.$formHelpers.merge({}, this.editedItem),
            })
          })
          .then(() => {
            this.isLoading = false
          })
      }
    },

    setModalTitle(title) {
      this.forceTitleSuffix = title
    },

    getNotValidFields(formRefer) {
      const notValidFiels = {}
      if (formRefer?.inputs) {
        formRefer.inputs.forEach((input) => {
          if (input.$attrs['data-field'] && !input.valid) {
            return (notValidFiels[input.$attrs['data-field']] = true)
          }
        })
      }
      return notValidFiels
    },
  },
}
